module.exports = __webpack_public_path__ + "static/media/logo.9cb8b107.png";